package one.healthium.tasks.navigation

import com.arkivanov.decompose.ComponentContext

class DefaultDailyTasksComponent(
    componentContext: ComponentContext,
    private val onLogWeightTaskClicked: (taskId: String) -> Unit,
    private val onLogWaterTaskClicked: (taskId: String) -> Unit,
    private val onLogFoodTaskClicked: (taskId: String) -> Unit,
    private val onReadInsightTaskClicked: (insightId: String) -> Unit,
    private val onDoWorkoutTaskClicked: (workoutId: String) -> Unit,
    private val onLogSymptomsTaskClicked: (taskId: String) -> Unit,
) : DailyTasksComponent, ComponentContext by componentContext {
    override fun onLogWeightTaskClicked(taskId: String) {
        onLogWeightTaskClicked.invoke(taskId)
    }

    override fun onLogWaterTaskClicked(taskId: String) {
        onLogWaterTaskClicked.invoke(taskId)
    }

    override fun onLogFoodTaskClicked(taskId: String) {
        onLogFoodTaskClicked.invoke(taskId)
    }

    override fun onReadInsightTaskClicked(insightId: String) {
        onReadInsightTaskClicked.invoke(insightId)
    }

    override fun onDoWorkoutTaskClicked(workoutId: String) {
        onDoWorkoutTaskClicked.invoke(workoutId)
    }

    override fun onLogSymptomsTaskClicked(taskId: String) {
        onLogSymptomsTaskClicked.invoke(taskId)
    }
}